import React from 'react';
import { useTranslation } from 'react-i18next';
import CautionIcon from '../../../../ASUPhotos/icons/me3_yellow_WarningIcon.svg';

function ClassPopUp({ hsClass, showCautionIcon, recommendedClass }) {
  const { t } = useTranslation();

  return (
    <div className="class-pop-up">
      <div className="header-class-indicator">
        {t('Selected Class:')}
        <span className="bold">
          {hsClass.requirement_title || hsClass.titleEn}
        </span>
      </div>
      {hsClass.learning_outcomes ? (
        <div className="class-indicator-class-desc">
          {hsClass.learning_outcomes}
        </div>
      ) : null}
      {/* TODO: Check if the placed class matches any of the recommended classes and display caution icon if not */}
      {!showCautionIcon ? (
        <div className="recommended-class-indicator">
          {t('Recommended Class:')}
          <span className="bold margin-left-5">{recommendedClass}</span>
          <img
            className="caution-icon"
            src={CautionIcon}
            alt={t('caution icon')}
          />
        </div>
      ) : null}
    </div>
  );
}

export default ClassPopUp;
